<template>
  <div class="school-data-grade">
    <div class="view-toggle">
      <Tabs :tabs="tabs" :selected="viewMode" @select="viewMode = $event"></Tabs>
    </div>
    
    <!-- Nuværende visning: Vikartimer -->
    <table v-if="viewMode === 'timer'" class="d-table">
      <thead>
      <tr>
        <th rowspan="2">
          <div class="grade-title">
            <div class="icon__bg-circle" v-if="events.length > 0" @click="isShowMore = !isShowMore"><span class="icon-arrow-down"></span></div>
            {{ calendarName }}
          </div>
        </th>
        <th>Antal skemabrikker</th>
        <th>Antal skemabrikker med vikar</th>
        <th>Antal klokketimer</th>
        <th>Antal klokketimer med vikar</th>
        <th></th>
      </tr>
      <tr>
        <th>{{ events.length }}</th>
        <th>{{ eventsWithSub.length }}</th>
        <th>{{ eventsInHours }}</th>
        <th> {{ eventsWithSubInHours }}</th>
        <th></th>
      </tr>
      </thead>
      <tbody v-if="isShowMore">
      <tr v-for="(subject, prop) in eventsInPools">
        <td>{{ prop }}</td>
        <td>{{ subject['events'] }}</td>
        <td>{{ subject['eventsWithSubs'] }}</td>
        <td>{{ subject['durationInHours'] }}</td>
        <td>{{ subject['durationWithSubsInHours'] }}</td>
        <td></td>
      </tr>
      </tbody>
    </table>
  
    <!-- Ny visning: Vikarer pr. klasse -->
    <table v-if="viewMode === 'subs'" class="d-table">
      <thead>
      <tr>
        <th>{{ calendarName }}</th>
        <th>{{ eventsWithSubInHours || 0 }}</th>
      </tr>
      </thead>
      <tbody>
          <template v-for="klass in substitutesByKlass">
              <tr class="substitute-item" v-for="sub in klass.substitutes" :key="sub.calendarId">
                <td>{{ sub.name }}</td>
                <td>{{ formatMinutesToHours(sub.minutes) }}</td>
              </tr>
        </template>
        <tr v-if="substitutesByKlass.length === 0">
          <td colspan="2" class="text-center">Ingen vikarer fundet</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import Tabs from '../common/Tabs.vue'
export default {
  components: {
    Tabs
  },
  props: {
    calendar: {
      type: Object,
      default: null
    },
    eventsInHash: {
      type: Object,
      default: () => {
      }
    }
  },
  data () {
    return {
      isShowMore: false,
      viewMode: 'timer', // 'timer' eller 'subs'
      tabs: [
        {
          title: 'Vikartimer',
          id: 'timer'
        },
        {
          title: 'Vikarer pr. klasse',
          id: 'subs'
        }
      ]
    }
  },
  computed: {
    events () {
      return this.eventsInHash[this.calendar.id] ? this.eventsInHash[this.calendar.id] : []
    },
    calendarName () {
      return this.calendar ? this.calendar.name : ''
    },
    eventsInPools () {
      let events = {}
      this.events.forEach(event => {
        if (!events[event.title]) {
          events[event.title] = {
            events: 0,
            eventsWithSubs: 0,
            durations: [0],
            durationsWithSubs: [0]
          }
        }
        events[event.title]['events'] += 1
        events[event.title]['durations'].push(event.v_duration)
        if (event.v_has_substitute) {
          events[event.title]['eventsWithSubs'] += 1
          events[event.title]['durationsWithSubs'].push(event.v_duration)
        }
      })
      for (const key in events) {
        const sumInHours = (events[key]['durations'].reduce((a, b) => a + b)) / 60
        events[key]['durationInHours'] = parseFloat(sumInHours).toFixed(2)
        const sumOfDurationsWithSubs = (events[key]['durationsWithSubs'].reduce((a, b) => a + b)) / 60
        events[key]['durationWithSubsInHours'] = parseFloat(sumOfDurationsWithSubs).toFixed(2)
      }
      return events
    },
    eventsInHours () {
      return this.getEventsInHours(this.events)
    },
    eventsWithSubInHours () {
      return this.getEventsInHours(this.eventsWithSub)
    },
    eventsWithSub () {
      return this.events.filter(event => {
        let hasSub = false
        event.calendars.forEach(calendar => {
          if (calendar.substitute) {
            hasSub = true
          }
        })
        return hasSub
      })
    },
    allUsersInHash () {
      return this.$store.getters.allUsersInHash
    },
    allUsersInCalIdHash () {
      return this.$store.getters.allUsersInCalIdHash
    },
    allCalendarsInHash () {
      return this.$store.getters.allCalendarsInHash
    },
    substitutesByKlass () {
      const klassMap = {}
      const allUsersInCalIdHash = this.$store.getters.allUsersInCalIdHash || {}
      const currentCalendarId = this.calendar ? this.calendar.id : null

      if (!currentCalendarId) {
        return []
      }

      this.events.forEach(event => {
        // Find kun klasser i eventet der matcher den aktuelle kalender
        let klassCalendars = []
        if (this.calendar.type === 'klass' || this.calendar.type === 'club') {
          const calendarType = this.calendar.type
          klassCalendars = event.calendars.filter(cal =>
            cal.calendar_type === calendarType && cal.calendar_id === currentCalendarId
          )
        }

        klassCalendars.forEach(klassCal => {
          const klassName = klassCal.name || klassCal.calendar_id
          if (!klassMap[klassName]) {
            klassMap[klassName] = {
              name: klassName,
              substitutes: {},
              totalMinutes: 0
            }
          }
          // Find vikarer i eventet
          // En vikar er en user calendar hvor substitute property er sat (dette er user_id for den originale lærer)
          event.calendars.forEach(cal => {
            if (cal.calendar_type === 'user' && cal.substitute) {
              // cal.substitute er user_id for den originale lærer
              // cal.calendar_id er calendar_id for vikaren
              // cal.name er navnet på vikaren
              const substituteCalId = cal.calendar_id
              const substituteUserId = allUsersInCalIdHash[substituteCalId]
                ? allUsersInCalIdHash[substituteCalId].id
                : null
              const substituteName = cal.name || (substituteUserId && this.allUsersInHash[substituteUserId]
                ? this.allUsersInHash[substituteUserId].name
                : `Vikar ${substituteCalId}`)
              // Brug calendar_id som key for at undgå duplikater
              const key = substituteCalId
              if (!klassMap[klassName].substitutes[key]) {
                klassMap[klassName].substitutes[key] = {
                  userId: substituteUserId,
                  calendarId: substituteCalId,
                  name: substituteName,
                  minutes: 0
                }
              }
              // Tilføj minutter for denne vikar
              const minutes = cal.minutes || event.v_duration || 0
              klassMap[klassName].substitutes[key].minutes += minutes
              klassMap[klassName].totalMinutes += minutes
            }
          })
        })
      })
      // Konverter til array og formater
      return Object.keys(klassMap).map(klassName => {
        const klass = klassMap[klassName]
        const substitutesArray = Object.values(klass.substitutes)
          .sort((a, b) => b.minutes - a.minutes) // Sorter efter minutter, højeste først
        const totalHours = (klass.totalMinutes / 60).toFixed(2)
        return {
          name: klassName,
          substitutes: substitutesArray,
          substituteCount: substitutesArray.length,
          totalHours: totalHours
        }
      }).sort((a, b) => a.name.localeCompare(b.name))
    }
  },
  methods: {
    getEventsInHours (events) {
      const eventsDurations = [0]
      events.forEach(event => {
        eventsDurations.push(event.v_duration)
      })
      const sum = eventsDurations.reduce((a, b) => a + b)
      const inHours = sum / 60
      return parseFloat(inHours).toFixed(2)
    },
    formatMinutesToHours (minutes) {
      const hours = (minutes / 60).toFixed(2)
      return hours.replace('.', ',')
    }
  }
}
</script>


<style scoped>
.school-data-grade {
  max-width: 1440px;
  box-shadow: 0 1px 2px rgb(0 0 0 / 7%);
  background: #fff;
  padding: 1rem;
  margin-bottom: 1rem;
}

.school-data-grade__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.d-table {
  width: 100%;
  border-collapse: collapse;
}

.d-table thead {
  background: #f6f9fc;
  border: 1px solid #e2e8f0;
  text-transform: uppercase;
  font-weight: 700;
}

.d-table thead tr:first-child th {
  border-bottom: 1px solid #e2e8f0;
}

.d-table thead tr:first-child th:first-child {
  border-right: 1px solid #e2e8f0;
}

.grade-title {
  display: flex;
  align-items: center;
}

.d-table thead tr th {
  padding: 8px 1rem;
}

.d-table thead tr:first-child th {
  text-transform: uppercase;
  font-weight: bold;
  color: #8898aa;
}

.d-table tbody {
  border: 1px solid #e2e8f0;
}

.d-table tbody tr:first-child td {
  padding: 0.5rem 1rem;
}

.d-table tr:first-child th:first-child,
.d-table tr td:first-child {
  width: 200px;
  text-align: left;
}

.d-table tr td,
.d-table tr th {
  padding: 0 1rem;
  text-align: right;
}

.d-table tbody tr:nth-child(even) {
  background: #f8fafb;
}

.d-table tbody tr:hover:not(:first-child) {
  background: aliceblue;
}

.view-toggle {
  display: flex;
  gap: 0.5rem;
  margin-bottom: 1rem;
}

.toggle-btn {
  padding: 0.5rem 1rem;
  border: 1px solid #e2e8f0;
  background: #fff;
  cursor: pointer;
  border-radius: 4px;
  transition: all 0.15s;
}

.toggle-btn:hover {
  background: #f6f9fc;
}

.toggle-btn--active {
  background: var(--blue);
  color: #fff;
  border-color: var(--blue);
}

.substitute-item {
  padding: 0.25rem 0;
}

.text-center {
  text-align: center;
  padding: 1rem;
  color: #8898aa;
}
</style>



// WEBPACK FOOTER //
// SchoolDataGrade.vue?0d15cdf9